"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getDropdownStyles = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _colors = _interopRequireDefault(require("../colors"));

var getDropdownStyles = function getDropdownStyles() {
  return {
    container: function container(styles) {
      return (0, _objectSpread2.default)({}, styles, {
        display: 'inline-block',
        width: '100%'
      });
    },
    control: function control(styles, _ref) {
      var isDisabled = _ref.isDisabled,
          isFocused = _ref.isFocused,
          menuIsOpen = _ref.menuIsOpen;
      isFocused = menuIsOpen;
      return (0, _objectSpread2.default)({}, styles, {
        borderColor: _colors.default.borderColor,
        boxShadow: 'none',
        color: _colors.default.black,
        cursor: 'pointer',
        fontSize: '0.95em',
        '&:hover': {
          borderColor: _colors.default.hoverBorderColor
        }
      }, isFocused ? {
        borderColor: _colors.default.dropdownBorderColor,
        borderRadius: '4px 4px 0 0',
        boxShadow: 'none',
        '&:hover': {
          borderColor: _colors.default.dropdownBorderColor
        }
      } : {}, isDisabled ? {
        background: _colors.default.white,
        opacity: 0.45
      } : {});
    },
    dropdownIndicator: function dropdownIndicator(styles) {
      return (0, _objectSpread2.default)({}, styles, {
        color: _colors.default.black,
        cursor: 'pointer'
      });
    },
    group: function group(styles) {
      return (0, _objectSpread2.default)({}, styles, {
        paddingTop: 0
      });
    },
    groupHeading: function groupHeading(styles) {
      return (0, _objectSpread2.default)({}, styles, {
        cursor: 'pointer'
      });
    },
    menu: function menu(styles) {
      return (0, _objectSpread2.default)({}, styles, {
        border: "1px solid ".concat(_colors.default.dropdownBorderColor),
        borderRadius: '0 0 4px 4px',
        borderTop: 'none',
        boxShadow: "0px 2px 3px 0px ".concat(_colors.default.borderColor),
        margin: '-1px -0.5px 0 0px'
      });
    },
    multiValue: function multiValue(styles) {
      return (0, _objectSpread2.default)({}, styles, {
        borderRadius: '0.2rem',
        lineHeight: '1.5em',
        width: '90%'
      });
    },
    multiValueLabel: function multiValueLabel(styles) {
      return (0, _objectSpread2.default)({}, styles, {
        color: _colors.default.multiLabelColor,
        fontSize: '1em',
        fontWeight: 'bold',
        width: '100%'
      });
    },
    multiValueRemove: function multiValueRemove(styles) {
      return (0, _objectSpread2.default)({}, styles, {
        paddingRight: '5px',
        ':hover': {
          color: _colors.default.hoverBorderColor
        }
      });
    },
    option: function option(styles, _ref2) {
      var isSelected = _ref2.isSelected;
      return (0, _objectSpread2.default)({}, styles, {
        background: isSelected ? _colors.default.selectedColor : 'none',
        color: _colors.default.black,
        cursor: 'pointer',
        fontSize: '0.95em',
        fontWeight: isSelected ? 'bold' : 'none',
        '&:hover': {
          background: _colors.default.transparentBlack
        }
      });
    },
    placeholder: function placeholder(styles) {
      return (0, _objectSpread2.default)({}, styles, {
        color: _colors.default.placeholderColor
      });
    },
    valueContainer: function valueContainer(styles) {
      return (0, _objectSpread2.default)({}, styles, {
        paddingRight: 0
      });
    }
  };
};

exports.getDropdownStyles = getDropdownStyles;

var formatGroupLabel = function formatGroupLabel(data) {
  return _react.default.createElement("div", null, _react.default.createElement("span", null, data.label));
};

var Dropdown = function Dropdown(props) {
  return _react.default.createElement(_reactSelect.default, (0, _extends2.default)({
    formatGroupLabel: formatGroupLabel,
    styles: getDropdownStyles()
  }, props));
};

var _default = Dropdown;
exports.default = _default;